import { Event_Source_Type } from "../../../constant/event";

import { DimensionEvent } from "./base";

export class DimensionClickEvent extends DimensionEvent {
    constructor() {
        super(...arguments), this.onClick = params => {
            if (!params) return;
            const x = params.event.viewX, y = params.event.viewY, targetDimensionInfo = this.getTargetDimensionInfo(x, y);
            targetDimensionInfo && this._callback.call(null, Object.assign(Object.assign({}, params), {
                action: "click",
                dimensionInfo: targetDimensionInfo.slice()
            }));
        };
    }
    register(eType, handler) {
        this._callback = handler.callback, this._eventDispatcher.register("pointertap", {
            query: Object.assign(Object.assign({}, handler.query), {
                source: Event_Source_Type.chart
            }),
            callback: this.onClick
        });
    }
    unregister() {
        this._eventDispatcher.unregister("pointertap", {
            query: null,
            callback: this.onClick
        });
    }
}
//# sourceMappingURL=dimension-click.js.map
